/**
 * Text helpers for article-only renderer code (G2). Locale maps ({[locale]: text}) resolve like
 * LocalizedLabel translations: exact locale → same language → first available.
 */
import type { LocalizedLabel } from '@segmently/schema-models/v2';
import { resolveLabel } from '@modules/screen-view-v2/utils/contentResolver';

export function resolveLocaleText(map: Record<string, string> | undefined | null, locale: string): string {
  if (!map || typeof map !== 'object') return '';
  const text = resolveLabel({ kind: 'static', translations: map } as unknown as LocalizedLabel, locale);
  return typeof text === 'string' ? text : '';
}

/** Label text without template markup: `<tag>x</tag>` → x, `@name` → name, `{{var}}` → removed. */
export function toPlainText(text: string): string {
  return text
    .replace(/<[^>]*>/g, '')
    .replace(/\{\{[^}]*\}\}/g, ' ')
    .replace(/@([^\s@<>]+)/g, '$1')
    .replace(/\s+/g, ' ')
    .trim();
}
